module.exports = "/_next/static/images/CollectDataTabs-2@2x-c9f5ff984c5484918d4fd3ec29840bc0.png";